module.exports = __webpack_public_path__ + "static/38-1caf372766dd398ef1cf63f437d1f9c4.jpg";